import React, { useState, useEffect } from "react";
import content from "./json/content.json";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { ThreeDots } from "react-loader-spinner";
import { Row, Col, Container, Table } from "react-bootstrap";
import i18next from 'i18next';

export default function Errors() {
  const { promiseInProgress } = usePromiseTracker();
  const [contentdata, setcontentdata] = useState([]);
  const [allLanguage, setAllLanguage] = useState("english");

  useEffect(() => {
    // trackPromise(
    //   new Promise((resolve) => {
    //     setTimeout(() => {
    setcontentdata(content[allLanguage === "english" ? 'en' : 'fr'].callback);
    //       resolve(); // ✅ Promise resolve karna zaroori hai
    //     }, 1000); // Simulated delay (1 second)
    //   })
    // );
  }, [allLanguage]);

  // Set language according current local
  useEffect(() => {
    i18next.changeLanguage(navigator.language === 'en-US' ? 'en' : 'fr'); // Change the i18next language
    localStorage.setItem("handleSelectedLanguage", navigator.language === 'en-US' ? 'english' : 'guinea');
  }, [navigator.language]);

  // Get handleSelectedLanguage from localStorage
  useEffect(() => {
    const storeHandleSelectedLanguage = localStorage.getItem('handleSelectedLanguage');
    if (storeHandleSelectedLanguage) {
      setAllLanguage(storeHandleSelectedLanguage); // Update state
    }
  }, [localStorage.getItem('handleSelectedLanguage')]); // Runs only on mount

  return (
    <>
      {contentdata.map((itemdata, index) => {
        return (
          <div className="mt-5" key={index}>
            <h5 className="h5-heading">{itemdata.titlename}</h5>
            <p className="p-pera">{itemdata.pracontent1}</p>
            <p className="p-pera">{itemdata.callbackurl}</p>
            <ol className="order-list-ind">
              {itemdata.pracontent.map((para, index) => {
                return (
                  <li key={index} className="p-pera">
                    {para}
                  </li>
                );
              })}
            </ol>
            <h5 className="h5-heading">{itemdata.titlename2}</h5>
            <p className="p-pera">{itemdata.pracontent2}</p>
            <p className="p-pera">{itemdata.webhookurl}</p>
            <ol className="order-list-ind">
              {itemdata.pracontent3.map((para, index) => {
                return (
                  <li key={index} className="p-pera">
                    {para}
                  </li>
                );
              })}
            </ol>

            <h5 className="h5-heading">{itemdata.canceltitle}</h5>
            <p className="p-pera">{itemdata.pracontent3}</p>
            <p className="p-pera">{itemdata.cancelurl}</p>
            <ol className="order-list-ind">
              {itemdata.pracontent4.map((para, index) => {
                return (
                  <li key={index} className="p-pera">
                    {para}
                  </li>
                );
              })}
            </ol>
          </div>
        );
      })}
    </>
  );
}
